import { IconButton, IconButtonProps, Tooltip } from "@mui/material";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import React from "react";
import { useIntl } from "react-intl";

const CopyIconButton = (props: IconButtonProps) => {
  const { formatMessage: t } = useIntl();
  return (
    <Tooltip title={t({ id: "copyLabel" })}>
      <span>
        <IconButton {...props}>
          <FileCopyIcon />
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default CopyIconButton;
